export default V => [
  {
    name: 'xml-reports.reports',
    path: '/xml-reports',
    component: V('xmlReports/Reports'),
    meta: {
      title: 'Gerar xml',
      breadcrumb: [{ title: 'Gerar xml' }],
    },
  },
]
